module.exports = __webpack_public_path__ + "media/images/photo/plans/common/img_dress-photo-eac239ee48cde92078c4ff1375d34fc5.jpg";